<!--
 * @Author: fanxiaoning
 * @Date: 2021-03-11 19:59:59
 * @LastEditors: fanxiaoning
 * @LastEditTime: 2022-08-17 17:34:35
-->
<template>
  <div class="app-wrap">
    <openApp v-if="openapp"></openApp>
    <openApp-popUp v-if="!msb1v1app" ref="popup"></openApp-popUp>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import openApp from "@/components/openApp/index.vue";
import openAppPopUp from "@/components/openApp/popup.vue";
import { utils } from "msb-public-library";
import Gray from "@/utils/gray";

export default Vue.extend({
  components: { openApp, openAppPopUp },

  computed: {
    openapp() {
      return this.$route.query.openapp && !utils.client.msb1v1app;
    },
    msb1v1app() {
      return utils.client.msb1v1app;
    },
    jumpSource() {
      return this.$route.query.jumpSource;
    }
  },

  created() {
    if (this.jumpSource) {
      console.log("来源 :>> ", this.jumpSource);
    }
  },
  watch: {
    // "$route.path"() {
    //   new Gray(this);
    // }
  }
});
</script>
